// import { Event, Message } from 'kts-scaffold-framework/message';

/** 例子代码 */
// class Demo extends Event {
//
//     /** 当前对象的类型 */
//     public static readonly TYPE: string = Message.createType('DemoEvent');
//
//     constructor() {
//         super(Demo.TYPE); // 类型传入基类
//     }
// }

export default {
};


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/InvoiceDetails/Modules.Event.ts